import React from 'react';
import DebugLotMapping from '../components/DebugLotMapping';
import PageBanner from '../components/Layout/PageBanner';

/**
 * A temporary page for debugging lot mapping issues
 * This page should be removed after debugging is complete
 */
const DebugLotMappingPage: React.FC = () => {
  return (
    <div className="flex flex-col h-screen">
      <PageBanner />
      <div className="container mx-auto p-4 flex-grow">
        <h1 className="text-2xl font-bold mb-4">Debug Lot Mapping</h1>
        <div className="bg-white rounded-lg shadow-md">
          <DebugLotMapping />
        </div>
      </div>
    </div>
  );
};

export default DebugLotMappingPage;
